import { styled } from 'styled-components';

import { colors, shadows } from '#/theme/theme';

export const StyledArrowButton = styled.button<{
  $variant: 'primary' | 'secondary';
}>`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.$variant === 'primary' ? colors.brandBlue : colors.white};
  border-radius: 100%;
  transition: 0.3s all ease;
  box-shadow: ${(props) =>
    props.$variant === 'primary' ? 'none' : shadows.low};

  &:not(:disabled) {
    pointer-events: all;
  }

  &:disabled {
    opacity: 0.5;
  }

  &:hover {
    box-shadow: ${shadows.low};
  }
`;
